import type { IRoutesLinksResponse } from './types';

export default function (
  defaultLocale: string,
  routes: {
    title: any;
    url?: string;
    enabled?: boolean;
    name?: string;
    id?: string;
    class?: string;
    countries?: string[];
    external?: boolean;
    anchor?: string }[],
): IRoutesLinksResponse[] {
  return routes
    .filter((route) => route?.countries?.includes(defaultLocale) || !route.countries)
    .filter((route) => route.enabled || route.enabled !== false)
    .map((route) => ({ ...route }));
}
